<template>
<div id="kcp-pay" class="kcp-pay">

    <!-- PC 결제폼 -->
    <form v-if="detect === 'pc'" ref="pcForm" name="order_info" action="/api/plugins/kcp/pay/response" method="post" enctype="application/x-www-form-urlencoded">
        <input type="hidden" name="ordr_idxx"  :value="orderNo">
        <input type="hidden" name="pay_method" value="110000000000">

        <input type="hidden" name="good_name" :value="orderName">
        <input type="hidden" name="good_mny"  :value="paymentAmount" maxlength="9">
        <input type="hidden" name="buyr_name" :value="buyerName">
        <input type="hidden" name="buyr_mail" :value="buyerEmail" maxlength="30">
        <input type="hidden" name="buyr_tel1" :value="buyerPhone">
        <input type="hidden" name="buyr_tel2" >
        <input type='hidden' name='quotaopt' value='12'> <!-- 할부옵션 -->

        <!-- 에스크로정보 : 에스크로 사용업체에 적용되는 정보입니다. -->
        <input type='hidden' name='rcvr_name' size='20'> <!-- 수취인 이름 -->
        <input type='hidden' name='rcvr_tel1' size='20'> <!-- 수취인 전화번호 -->
        <input type='hidden' name='rcvr_tel2' size='20'> <!-- 수취인 휴대폰번호 -->
        <input type='hidden' name='rcvr_mail' size='40'> <!-- 수취인 E-Mail -->
        <input type='hidden' name='rcvr_zipx' size='6'> <!-- 수취인 우편번호 -->
        <input type='hidden' name='rcvr_add1' size='50'> <!-- 수취인 주소 -->
        <input type='hidden' name='rcvr_add2' size='50'> <!-- 수취인 상세주소 -->

        <!-- 필수 항목 -->
        <!-- 요청종류 승인(pay)/취소,매입(mod) 요청시 사용 -->
        <input type='hidden' name='req_tx' value="pay">
        <!-- 테스트 결제시 : T0007 으로 설정, 리얼 결제시 : 부여받은 사이트코드 입력 -->
        <input type='hidden' name='site_cd' :value="isDeduction ? siteCodeDeduction : siteCode">
        <!-- MPI 결제창에서 사용 한글 사용 불가 -->
        <input type='hidden' name='site_name' :value="siteName">
        <!-- http://testpay.kcp.co.kr/Pay/Test/site_key.jsp 로 접속하신후 부여받은 사이트코드를 입력하고 나온 값을 입력하시기 바랍니다. -->
        <input type='hidden' name='site_key' :value="isDeduction ? siteKeyDeduction : siteKey">

        <!-- 필수 항목 : PULGIN 설정 정보 변경하지 마세요 -->
        <input type='hidden' name='module_type' value='01'>

        <!-- 필수 항목 : 결제 금액/화폐단위 -->
        <input type='hidden' name='currency' value='WON'>

        <!-- 주문 번호 (자바 스크립트 샘플(init_orderid()) 참고) -->

        <!-- 교통카드 테스트용 파라미터 (교통카드 테스트 시에만 이용하시기 바랍니다.) -->
        <!--input type='hidden' name='test_flag' value='T_TEST'//-->

        <!-- 에스크로 항목 -->

        <!-- 에스크로 사용 여부 : 반드시 Y 로 세팅 -->
        <input type='hidden' name='escw_used' value='Y'>

        <!-- 에스크로 결제처리 모드 : 에스크로: Y, 일반: N, KCP 설정 조건: O -->
        <input type='hidden' name='pay_mod' value='O'>

        <!-- 배송 소요일 : 예상 배송 소요일을 입력 -->
        <input type='hidden' name='deli_term' value='03'>

        <!-- 장바구니 상품 개수 : 장바구니에 담겨있는 상품의 개수를 입력 -->
        <input type='hidden' name='bask_cntx' value='1'>

        <!-- 장바구니 상품 상세 정보 (자바 스크립트 샘플(create_goodInfo()) 참고) -->
        <input type='hidden' name='good_info' value=''>

        <!-- 필수 항목 : PLUGIN에서 값을 설정하는 부분으로 반드시 포함되어야 합니다. ※수정하지 마십시오.-->
        <input type="hidden" name="res_cd" />
        <input type="hidden" name="res_msg" value="" />
        <input type="hidden" name="tno" value="" />
        <input type="hidden" name="trace_no" value="" />
        <input type="hidden" name="enc_info" />
        <input type="hidden" name="enc_data" />
        <input type="hidden" name="ret_pay_method" value="" />
        <input type="hidden" name="tran_cd" />
        <input type="hidden" name="bank_name" value="" />
        <input type="hidden" name="bank_issu" value="" />
        <input type="hidden" name="use_pay_method" />

        <!--  현금영수증 관련 정보 : Payplus Plugin 에서 설정하는 정보입니다 -->
        <input type="hidden" name="cash_tsdtime" value="" />
        <input type="hidden" name="cash_yn" />
        <input type="hidden" name="cash_authno" value="" />
        <input type="hidden" name="cash_tr_code" />
        <input type="hidden" name="cash_id_info" value="" />

    </form>

    <form v-else ref="mobileForm" name="order_info" :action="payUrl" method="post" accept-charset="euc-kr">
        <input type='hidden' name='ordr_idxx' :value="orderNo">
        <input type='hidden' name='good_name' :value="orderNo" size='30'> <!-- 상품명 -->
        <input type='hidden' name='good_mny'  :value="paymentAmount" size='10'> <!-- 결제금액 -->
        <input type='hidden' name='buyr_name' :value="buyerName" size='20'> <!-- 주문자명 -->
        <input type='hidden' name='buyr_mail' :value="buyerEmail" size='25'> <!-- E-Mail -->
        <input type='hidden' name='buyr_tel1' :value="buyerPhone" size='20'> <!-- 전화번호 -->
        <input type='hidden' name='buyr_tel2' value='' size='20'> <!-- 휴대폰번호 -->
        <input type='hidden' name='payment' value='' size='20' />
        <input type='hidden' name='course' value='' size='20' />

        <!-- 공통정보 -->
        <input type="hidden" name="req_tx" value="pay"> <!-- 요청 구분 -->
        <input type="hidden" name="shop_name" :value="siteName"> <!-- 사이트 이름 -->
        <input type="hidden" name="site_cd" :value="isDeduction ? siteCodeDeduction : siteCode"> <!-- 사이트 코드 -->
        <input type="hidden" name="currency" value="410" /> <!-- 통화 코드 -->
        <input type="hidden" name="eng_flag" value="N" /> <!-- 한 / 영 -->
        <!-- 결제등록 키 -->
        <input type="hidden" name="approval_key" :value="approvalKey" id="approval">
        <!-- 인증시 필요한 파라미터(변경불가)-->
        <input type="hidden" name="escw_used" value="N">
        <input type="hidden" name="pay_method" value="CARD">
        <input type="hidden" name="van_code" value="">
        <!-- 신용카드 설정 -->
        <input type="hidden" name="quotaopt" value="12" /> <!-- 최대 할부개월수 -->
        <!-- 가상계좌 설정 -->
        <input type="hidden" name="ipgm_date" :value="ipgmDate" />
        <!-- 가맹점에서 관리하는 고객 아이디 설정을 해야 합니다.(필수 설정) -->
        <input type="hidden" name="shop_user_id" value="" />
        <!-- 복지포인트 결제시 가맹점에 할당되어진 코드 값을 입력해야합니다.(필수 설정) -->
        <input type="hidden" name="pt_memcorp_cd" value="" />
        <!-- 현금영수증 설정 -->
        <input type="hidden" name="disp_tax_yn" value="Y" />
        <!-- 리턴 URL (kcp와 통신후 결제를 요청할 수 있는 암호화 데이터를 전송 받을 가맹점의 주문페이지 URL) -->
        <input type="hidden" name="Ret_URL" :value="returnUrl" >
        <!-- 화면 크기조정 -->
        <input type="hidden" name="tablet_size" value="1.0">
        <!-- 앱으로 다시 돌아오기-->>
        <input type="hidden" name="AppUrl" value="daehanbooks://"/>


        <!-- 추가 파라미터 ( 가맹점에서 별도의 값전달시 param_opt 를 사용하여 값 전달 ) -->
        <input type="hidden" name="param_opt_1" >
        <input type="hidden" name="param_opt_2" >
        <input type="hidden" name="param_opt_3" >

    </form>

    
</div>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect"
export default {
    data() {
        return {
            // KCP PAY 설정값
            siteName: null,
            siteCode: null,
            siteKey: null,
            siteCodeDeduction: null,
            siteKeyDeduction: null,

            // 결제정보
            orderNo: "",
            orderName: "",
            paymentAmount: 0,
            buyerName: "",
            buyerPhone: "",
            buyerEmail: "",

            // 모바일 결제등록 정보
            payUrl: "",
            approvalKey: "",
            returnUrl: "",

            // 대한문고 커스텀
            isDeduction: false,

            detect
        }
    },
    async mounted() {
        let { siteName, siteCode, siteKey, siteCodeDeduction, siteKeyDeduction } = await api.plugins.kcp.pay.config.get();
        this.siteName = siteName;
        this.siteCode = siteCode;
        this.siteKey = siteKey;
        this.siteCodeDeduction = siteCodeDeduction;
        this.siteKeyDeduction = siteKeyDeduction;

        window.authComplete = (payload) => {
            this.$emit("complete", payload);
            this.$emit("change", payload);
            this.$emit("input", payload);
            this.show = false;
        };
    },
    beforeDestroy() {
        window.authComplete = undefined;
    },
    methods: {
        validate(){
            try{
                if(!this.orderNo) throw new Error("주문번호를 입력해주세요");
                if(!this.orderName) throw new Error("주문명칭 또는 상품이름을 입력해주세요");
                if(!this.paymentAmount) throw new Error("결제금액을 입력해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async pay() {
            if(this.validate()){
                console.log(detect);
                if(detect === 'pc'){
                    this.$nextTick( _ => KCP_Pay_Execute(document.order_info) );
                }
                else{
                    let { approvalKey, payUrl } = await api.plugins.kcp.pay.approval({ orderNo: this.orderNo });

                    this.payUrl = payUrl;
                    this.approvalKey = approvalKey;
                    this.returnUrl = `${window.location.protocol.replace(/[^a-z]/g ,'')}://${window.location.host}/api/plugins/kcp/pay/response`;
                    this.$nextTick( _ => this.$refs["mobileForm"].submit());
                }
            }
        },
    },
    computed: {
        ipgmDate(){
            return this.$dayjs().format("YYYYMMDD");
        },
    }
};
</script>

<style>
#kcp-pay .screen {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99999;
    overflow-y: scroll;
    background: rgba(0,0,0,0.5);
}
#kcp-pay iframe {
    position: fixed;
    width: 100%;
    height: 100%;
}
.kcp-pay .progress{
    position: fixed;
    width: 100%;
    height: 100%;
    left:0;
    top: 0;
    background: rgba(0,0,0,0.54);
}
.kcp-pay .spinner {
    position: fixed;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 28px;
    width: 28px;
    animation: rotate 0.8s infinite linear;
    border: 8px solid #fff;
    border-right-color: transparent;
    border-radius: 50%;
}
@keyframes rotate {
    0%    { transform: rotate(0deg); }
    100%  { transform: rotate(360deg); }
}
</style>
